import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAlliedmoddersComponent } from './simple-icons-alliedmodders.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAlliedmoddersComponent ],
    exports:      [ SimpleIconsAlliedmoddersComponent ],
    bootstrap:    []
})
export class SimpleIconsAlliedmoddersModule {}
